<template>
    <v-dialog v-model="model" max-width="600px" persistent>
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div>
                        <v-layout align-center>
                            <v-icon size="12px" color="white" class="mr-2">fa-trash fa-fw</v-icon> 
                            <div class="white--text font-weight-medium caption">DELETE</div> 
                        </v-layout>
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('cancel')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pt-8">
                <div class="black--text body-1 text-center">
                    {{text}}
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center" :class="(loading) ? 'pa-1' : 'pa-4'">
                <v-btn text large class="info--text text--darken-1" @click="$emit('cancel')" v-if="!loading">Cancel</v-btn>
                <v-btn text large class="red darken-2 white--text" @click="emit" v-if="!loading">Delete</v-btn>
                <SendingLoader v-if="loading" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            loading: false
        }
    },
    props: ['model', 'text'],
    watch: {
        model(val) {
            if (val == false) {
                this.loading = false;
            }
        }
    },
    methods: {
        emit() {
            this.loading = true;
            this.$emit('remove');
        }
    }
}
</script>

